import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

const useStyles = makeStyles({
  avatar: {
    width: '24px',
    height: '24px',
    fontSize: '12.8px',
    lineHeight: '21.12px',
    fontWeight: 700,
    marginRight: '20px',
    marginLeft: '6px',
    fontFamily: 'Source Sans Pro',
    color: colors.resiliaWhite,
    background: colors.darkGrey,
  },
  avatarTooltip: {
    background: colors.darkestBlue,
    color: colors.resiliaWhite,
    borderRadius: '8px',
    fontWeight: 700,
    fontSize: '16px',
    padding: '20px',
    border: 'none',
  },
  avatarTooltipArrow: {
    color: colors.darkestBlue,
    transform: 'translate(-4px)',
  },
})

export default useStyles
